import React, { useState, useEffect, useCallback } from 'react';
// import { Input, FormGroup, Modal,ModalBody,ModalHeader, Row,Col, Label,
//     Nav, NavItem, NavLink, TabContent, TabPane,ModalFooter,Button  } from 'reactstrap';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import './index.scss';
import toastr from 'toastr';
// import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { hideUpdProj, showUpdProj } from '../redux/ctrl/ctrlActions';
// import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
//import getDt from '../../utils';
//import getDt from '../../utils';
import getDt, { fetchAppAccUsers, fetchProductsById } from '../../utils';
import { getDtfrmt } from '../../utils';
import { createPrjAsn, fetchPrjAsn, updatePrjAsn } from '../redux/prjasn/prjAsnActions';
import { updateProjectAct, fetchMasterProjects } from '../redux/project/projActions';
import { showLoader, refreshApp } from '../redux/ctrl/ctrlActions';
import { BsStarFill, BsStar } from "react-icons/bs";
// import { FiStar } from "react-icons/fi";
import TextInput from '../shared/TextInput';
import DateInput from '../shared/Dateinput';
import SelectInput from '../shared/Selectinput';
//import ButtonO from '../shared/ButtonO';
import ButtonC from '../shared/ButtonC';
import HOC from '../HOC/HOC';
import gifLoader from '../../../src/assets/images/load.gif';
import { showHideElem, fetchUsers, debounce } from '../../utils';
import { Button, MenuItem, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
// import {wrtAccs} from "../../components/redux/prjasn/prjAsnActions"

import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from 'react-i18next';

const disb = false;
function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
        //   cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};


const UpdateProject = ({ isDisabled = false }) => {
    const [showSrchSel, setShowSrchSel] = useState(false);
    const sctrl = useSelector((state) => state.ctrl);
    const udata = useSelector(state => state.prjasn.projectsAsn);

    const { t, i18n } = useTranslation();

    // const write = useSelector((state) => state.projectData);
    // const abc=useSelector((state)=>state.prjasn.projectsAsn)
    const [fltrdPriceList, setFltrdPriceList] = useState([]);
    const masterProjects = useSelector(state => state.project.master_projects);
    const [showMsPrjhSel, setShowMsPrjhSel] = useState(false);
    const [showPLSel, setShowPLSel] = useState(false);

    const [projNumberChanged, setProjectNumberChanged] = useState(false);
    // console.log("projNumberChangedprojNumberChangedprojNumberChanged", projNumberChanged)

    //const [showGLoader, setShowGLoader] = useState(false);
    // const [uproj, setUproj] = useState({...sctrl.data});
    let uproj = { ...sctrl.data }
    const [dueDate, setDueDate] = useState(new Date());
    const [priceDate, setPriceDate] = useState(null);
    const [isMstr, setMstr] = useState((sctrl.data.master_prj === "Y") ? true : false);

    const [endDest, setEndDest] = useState(sctrl.data.end_dest);
    const [priceReg, setPriceReg] = useState(sctrl.data.pricing_region);
    const [curr, setCurrency] = useState(sctrl.data.currency);
    const [tierValue, setTierValue] = useState(sctrl.data.tier || '');
    const [errors, setErrors] = useState({});
    const profileState = useSelector((state) => state.profile);
    const updA = profileState.capb.findIndex(o => o.PWSUPPRJ === 'Y') >= 0 ? false : true;
    const TINP = useCallback(HOC(TextInput, updA), [updA]);
    const DINP = HOC(DateInput, disb);
    const SINP = useCallback(HOC(SelectInput, updA), [updA]);
    //  const BtnO = useCallback( HOC(ButtonO,disb),[]);
    const BtnC = useCallback(HOC(ButtonC, disb), []);
    const [projStatus, setProjStatus] = useState(uproj.project_status || sctrl.data.project_status);
    let errCnt = 0;
    const endDestLbl = sctrl.endDestOPt.filter(val => val.value === sctrl.data.end_dest).map(item => item.label)[0]
    const currLbl = sctrl.currencies.filter(val => val.value === sctrl.data.currency).map(item => item.label)[0]
    const prcRegLbl = sctrl.endDestOPt.filter(val => val.value === sctrl.data.pricing_region).map(item => item.label)[0]
    const [isFav, setFav] = useState(sctrl.data.favorite === 'Y' ? true : false)
    const stLabel = sctrl.projStatus.filter(val => val.value === sctrl.data.project_status).map(item => item.label)[0]
    const [prjstat, setPrjstat] = useState({ value: sctrl.data.project_status, label: stLabel });
    const [lpm, setLpm] = useState("");
    const [lpe, setLpe] = useState("");
    const [showADSel, setshowADSel] = useState(false);
    const [showADSel1, setshowADSel1] = useState(false);
    const [users, setUsers] = useState(null);
    const [user, setUser] = useState(null);
    // const [state, setState] = useState({projectData: []})  
    useEffect(
        () => {
            setFav(sctrl.data.favorite === ("Y") ? true : false);
            setMstr((sctrl.data.master_prj === "Y") ? true : false)
            // setPrjstat(sctrl.data.project_status)
            setPrjstat({ value: sctrl.data.project_status, label: stLabel })
            setLpm(sctrl.data.lead_project_manager);
            setLpe(sctrl.data.lead_project_engineer);
            setTierValue(sctrl.data.tier || '');
        }, [sctrl.data]
    )

    useEffect(() => {
        //dispatch(fetchPrjAsn());
    }, []);

    const [writeAcc, setWriteAcc] = useState();


    useEffect(() => {
        let write_accs = udata.filter((item) => item.project_id === sctrl.data?.project_id && profileState.email?.toLowerCase() === item.email_id?.toLowerCase())[0]?.write_access

        write_accs = sctrl.data.created_by?.toLowerCase() === profileState.email?.toLowerCase() || write_accs == 'Y' ? true : false
        if (!write_accs) {
            write_accs = (profileState.capb.findIndex((o) => o.PWSADACC === 'Y') >= 0 ? true : false);
        }
        setWriteAcc(write_accs)
    }, [udata, sctrl.data]);




    const ShowADNameSugg = async (event, val) => {
        if (event.key !== 'Escape') {
            const inp = event.target;
            setUser(null);
            let unfErr = '';
            inp.setCustomValidity('');
            if (inp.value.length >= 0) {
                inp.style.border = '1px solid #ced4da';
            }
            if (inp.value.length >= 3) {
                showHideElem(val.hideloader, 'show');
                const users = await fetchUsers(inp.value);
                if (users === 403) {
                    dispatch(refreshApp(true))
                }
                if (users !== null && users !== 403 && users !== undefined && users.length > 0) {
                    setUsers(users);
                    if (val.field === 'lead_project_manager') {
                        setshowADSel(true)
                        setLoadingLpm(false);
                        // setLpm(lpm)    
                        showHideElem(val.hideloader, 'hide');
                    }
                    else if (val.field === 'lead_project_engineer') {
                        setshowADSel1(true)
                        setLoadingLpe(false);
                        // setLpe(lpe);
                        showHideElem(val.hideloader, 'hide');
                        //setLpe(inp.value)                     
                    }

                } else {
                    unfErr = '**' + inp.value + ' Not Found.'
                    setUsers(null);
                    setshowADSel(false);
                    setLoadingLpm(false);
                    setLoadingLpe(false);
                    showHideElem(val.hideloader, 'hide');
                }
            } else {
                setshowADSel(false);
                setLoadingLpm(false);
                setLoadingLpe(false);
                showHideElem(val.hideloader, 'hide');
            }
            const tempErrors = { ...errors };
            if (unfErr !== '') {
                tempErrors[val.field] = unfErr;
            } else {
                delete tempErrors[val.field];
            }
            setErrors(tempErrors);
        }
    }

    const setCuser = (props) => {
        //{dispName:user.displayName, field:'lead_project_manager',loader:'adname_loader'}
        /*const tempUsers = [...users];
        let selUser;
        tempUsers.forEach((elem) => {
            if (elem.displayName === displayName) {
                selUser = elem;
            }
        });*/
        document.getElementById(props.field).value = props.dispName;//||selUser.givenName;
        //setUser(selUser);
        setUser(props.dispName)
        setshowADSel(false)
        setshowADSel1(false)
        showHideElem(props.loader, 'hide');
        setUsers(null);
    }



    const applyDebounce = useCallback(debounce(ShowADNameSugg), []);

    useEffect(() => {
        const keyDownHandler = event => {
            if (event.key === 'Escape') {
                //event.preventDefault();

                setUsers(null);
                setShowSrchSel(false);
                setshowADSel(false);
                setshowADSel1(false);
                showHideElem('adname_loader', 'hide');
                showHideElem('adname_loader1', 'hide');
            }
        };


        document.addEventListener('keydown', keyDownHandler);

        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, []);

    const closeAD = (props) => {
        setTimeout(function () {
            setshowADSel(false);
            showHideElem(props.loader, 'hide');
        }, 200)
    }

    const handleProject = (e) => {
        //setPrjstat(e.value)
        setProjStatus(e.value)
    }
    const handleEndDest = (e) => {
        setEndDest(e.value)
    }

    const handlePriceReg = (e) => {
        setPriceReg(e.value)
    }

    const handleCurrency = (e) => {
        setCurrency(e.value)
    }

    const mstrChk = (val) => {
        setMstr(val)
    }


    const valFields = (values) => {
        const errors = {}
        if (!values.project_name || values.project_name === undefined) {
            errors.project_name = "**Project Name is required";
            errCnt += 1;
        }
        if (!values.project_number || values.project_number === undefined) {
            errors.project_number = "**Project Number is required";
            errCnt += 1;
        }
        if (!values.tier || values.tier === undefined) {
            errors.tier = "**Tier is required";
            errCnt += 1;
        }
        /*  if (!values.project_manager){
             errors.project_manager = "**Project Manager is required";
             errCnt+=1;
         }
         if (!values.world_area){
             errors.world_area = "**World area is required";
             errCnt+=1;
         }        */
        setErrors(errors);


    }

    const updateProjct = async () => {
        if (updA || !writeAcc) {
            return;
        }
        var currentdate = new Date();
        uproj.last_mod_date = getDt(currentdate);
        uproj.project_name = document.getElementById('project_name').value;
        uproj.project_number = document.getElementById('project_number').value;
        uproj.tier = tierValue;
        //uproj.end_user_cust=document.getElementById('end_user_cust').value;
        //uproj.project_manager=document.getElementById('project_manager').value
        valFields(uproj)
        if (errCnt === 0) {
            let tempDate = getDt(new Date(uproj.start_date));
            console.log(uproj)
            if (tempDate.indexOf('-') === 0) {
                tempDate.slice(1);
                tempDate = tempDate.slice(1);
            }
            let productInfo
            if (projNumberChanged && document.getElementById('project_number').value !== "") {
                productInfo = await fetchProductsById(document.getElementById('project_number').value)

                if (productInfo === 403) {
                    dispatch(refreshApp(true))
                }
                if (Array.isArray(productInfo) && productInfo.length) {
                    toastr.error(t('This Project Number already exists.'))
                    return
                }

            }
            if (!projNumberChanged || (Array.isArray(productInfo) && !productInfo.length)) {
                dispatch(showLoader(true))
                const updPrj = {
                    project_id: uproj.project_id,
                    project_ws_id: uproj.project_ws_id,
                    owner_name: uproj.owner_name,
                    project_name: document.getElementById('project_name').value,
                    project_number: document.getElementById('project_number').value,
                    //master_prj: isMstr?'Y':'N',
                    crm_opp_num: document.getElementById('crm_opp_num').value,
                    tier: tierValue,
                    //end_user_cust:document.getElementById('end_user_cust').value,
                    //end_dest:endDest,
                    //  internal_qte_num:document.getElementById('internal_qte_num').value,
                    //endcust_prjref:document.getElementById('endcust_prjref').value,
                    project_status: prjstat.value,
                    //project_status:document.getElementById('project_status').value,
                    //due_date:uproj.due_date,
                    lead_project_manager: lpm ? lpm : "",
                    lead_project_engineer: lpe ? lpe : "",
                    world_area: document.getElementById('world_area').value,
                    //epc:document.getElementById('epc').value,
                    //    parent_project:document.getElementById('parent_project').value,
                    //operating_unit:uproj.operating_unit,
                    pdl_project_name: document.getElementById('pdl_project_name').value,
                    project_bg_info: document.getElementById('project_bg_info').value,
                    //master_project:document.getElementById('master_project').value,
                    //sub_project:document.getElementById('sub_project').value,
                    //currency:curr?curr:'USD',//document.getElementById('currency').value,
                    //pricing_region:document.getElementById('pricing_region').value,
                    //pricing_region:priceReg,
                    //pricing_date:priceDate?getDt(priceDate):null,
                    //pricelist:document.getElementById('pricelist').value,
                    last_updatedby: profileState.email,
                    start_date: uproj.start_date,
                    last_mod_date: getDt(new Date()),
                    //end_date:uproj.end_date,
                    //enabled_flag:uproj.enabled_flag,
                    created_by: uproj.created_by,
                    favorite: isFav ? 'Y' : 'N',
                    search: 'email'

                }
                dispatch(hideUpdProj(false))
                dispatch(updateProjectAct(updPrj))
                setProjectNumberChanged(false)
                setTimeout(() => { dispatch(updateProjectAct(updPrj)) }, 500)
            }
        }
    }

    useEffect(
        () => {
            if (sctrl.data.pricing_date !== null) {
                setPriceDate(new Date(sctrl.data.pricing_date))
            }
            if (sctrl.data.pricing_date === null) {
                setPriceDate(null);
            }
        }, [sctrl.updProject]
    )

    const [activeTab, setActiveTab] = useState('1')
    const dispatch = useDispatch()

    const customStyles = {}
    const handleChange = (e) => {
        e.preventDefault();
        console.log("sctrl", sctrl.data.project_number)
        let isChanged = e.target.value !== sctrl.data.project_number
        e.target.name === "project_number" && setProjectNumberChanged(isChanged)
        uproj[e.target.name] = e.target.value
    }


    const setMsPrj = (selElem) => {
        document.getElementById('master_project').value = selElem;
        setShowMsPrjhSel(false);
    }
    useEffect(() => {
        if (masterProjects !== null && masterProjects !== undefined && masterProjects.length > 0) {
            setShowMsPrjhSel(true);
        } else {
            setShowMsPrjhSel(false);
            //setShowGLoader(false);
        }
        showHideElem('master_project_loader', 'hide');
    }, [masterProjects]);

    const setWThHgt = (ref, target, arrSize) => {
        const selHgt = ['180px', '50px', '100px', '140px'];
        document.getElementById(target).style.width
            = document.getElementById(ref).offsetWidth + 'px';
        if (arrSize < 4) {
            document.getElementById(target).style.height = selHgt[arrSize];
        } else {
            document.getElementById(target).style.height = '180px';
        }
    }
    const showHideElem = (id, action) => {
        if (document.getElementById(id) !== null) {
            if (action === 'show') {
                document.getElementById(id).style.display = 'block';
            } else {
                document.getElementById(id).style.display = 'none';
            }
        }
    }
    const showMsPrjSel = async (event) => {
        const inp = event.target;
        const currMproj = sctrl.data.project_number + ' - ' + sctrl.data.project_name //sctrl.data.master_project!==undefined?sctrl.data.master_project:'';

        if (inp.value.length >= 3) {
            dispatch(fetchMasterProjects(inp.value, currMproj))
            showHideElem('master_project_loader', 'show');
        } else {
            setShowMsPrjhSel(false);
        }
    }

    useEffect(() => {
        if (fltrdPriceList !== null && fltrdPriceList !== undefined && fltrdPriceList.length > 0) {
            setShowPLSel(true);
        } else {
            setShowPLSel(false);
        }
        showHideElem('pricelist_loader', 'hide');
    }, [fltrdPriceList]);
    useEffect(() => {
        if (showPLSel && document.getElementById('pl-proj-sel') !== null) {
            setWThHgt('pricelist', 'pl-proj-sel', fltrdPriceList.length);
        }
        if (showMsPrjhSel && document.getElementById('master-proj-sel') !== null) {
            setWThHgt('master_project', 'master-proj-sel', masterProjects.length);
        }
    }, [showMsPrjhSel, showPLSel, fltrdPriceList, masterProjects])
    const showPriceLstSel = async (event) => {
        const inp = event.target;
        if (inp.value.length >= 3) {
            showHideElem('pricelist_loader', 'show');
            const tempPriceList = sctrl.priceList;
            const fltrdPriceList = tempPriceList.filter(elem => { return elem.value.toLowerCase().includes(inp.value.toLowerCase()) });
            setFltrdPriceList(fltrdPriceList);
        } else {
            setShowPLSel(false);
        }
    }

    const setPL = (selElem) => {
        document.getElementById('pricelist').value = selElem;
        setShowPLSel(false);
    }

    const closecSelD = () => {
        setTimeout(function () {
            setShowMsPrjhSel(false);
            setShowPLSel(false);
        }, 500)
    }




    //Lpm select Asynchronous function

    const [openLpm, setOpenLpm] = useState(false);
    const [optionsLpm, setOptionsLpm] = useState([]);
    const [loadingLpm, setLoadingLpm] = useState(false);

    useEffect(() => {
        if (!openLpm) {
            setOptionsLpm([]);
        }
    }, [openLpm]);

    useEffect(() => {
        if (lpm) {
            if (lpm.length >= 3 && openLpm) {
                setLoadingLpm(true);
                setOpenLpm(false);
                setTimeout(() => {
                    setOpenLpm(true);
                }, 100);

            }
        }
        if (!lpm) {
            setLoadingLpm(false);
        }
    }, [lpm]);

    useEffect(() => {
        if (showADSel && users) {
            setOptionsLpm([...users]);
        }
        if (!showADSel || !openLpm) {
            setOptionsLpm([]);
        }
    }, [showADSel, openLpm, users])

    const handleChangeLpm = (e) => {
        if (e && e.displayName) {
            setLpm(e.displayName);
        }
        if (typeof e === 'string') {
            setLpm(e);
        }
        if (e && e.key === 'Enter') {
            setLoadingLpm(false);
            setOpenLpm(false);
        }
        if (e === null) {
            setLpm(null)
        }
        setOptionsLpm([]);
        setshowADSel(false);
    }

    //Lpm select Asynchronous function




    //Lpe select Asynchronous function

    const [openLpe, setOpenLpe] = useState(false);
    const [optionsLpe, setOptionsLpe] = useState([]);
    const [loadingLpe, setLoadingLpe] = useState(false);

    useEffect(() => {
        if (!openLpe) {
            setOptionsLpe([]);
        }
    }, [openLpe]);

    useEffect(() => {
        if (lpe) {
            if (lpe.length >= 3 && openLpe) {
                setLoadingLpe(true);
                setOpenLpe(false);
                setTimeout(() => {
                    setOpenLpe(true);
                }, 100);

            }
        }
        if (!lpe) {
            setLoadingLpe(false);
        }
    }, [lpe]);

    useEffect(() => {
        if (showADSel1 && users) {
            setOptionsLpe([...users]);
        }
        if (!showADSel1 || !openLpe) {
            setOptionsLpe([]);
        }
    }, [showADSel1, openLpe, users])

    const handleChangeLpe = (e) => {
        if (e && e.displayName) {
            setLpe(e.displayName);
        }
        if (typeof e === 'string') {
            setLpe(e);
        }
        if (e && e.key === 'Enter') {
            setLoadingLpe(false);
            setOpenLpe(false);
        }
        if (e === null) {
            setLpe(null)
        }
        setOptionsLpe([]);
        setshowADSel1(false);
    }

    //Lpe select Asynchronous function
    const inputToSetSize = ['asynchronous-lead_project_manager', 'asynchronous-lead_project_engineer'];

    useEffect(() => {
        if (sctrl.updProject) {
            setTimeout(() => {
                inputToSetSize.map((id) => {
                    if (document.getElementById(id)) {
                        document.getElementById(id).setAttribute("maxlength", "240");
                    }
                })
            }, 1000)
        }
    }, [sctrl.updProject])

    return (
        <>
            <Dialog maxWidth="lg" open={sctrl.updProject}
                // onClose={(e) => { if (showADSel1 || showADSel) { setshowADSel1(false); setshowADSel(false); } else { dispatch(showUpdProj({ updProj: false, data: {} })); dispatch(updateProjectAct(sctrl.data)); setErrors({}); setUsers(null); setShowSrchSel(false); setshowADSel(false); setshowADSel1(false); showHideElem('adname_loader', 'hide'); showHideElem('adname_loader1', 'hide'); dispatch(hideUpdProj(false)) } }} 
                onClose={() => { setProjectNumberChanged(false); dispatch(showUpdProj({ updProj: false, data: uproj })); setErrors({}); setUsers(null); setShowSrchSel(false); setshowADSel(false); setshowADSel1(false); showHideElem('adname_loader', 'hide'); showHideElem('adname_loader1', 'hide'); dispatch(hideUpdProj(false)) }}
                className="update-project muiForm-Modal" PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title">
                <DialogTitle className="model-title" id="draggable-dialog-title">{t('MyProject Workspace ID')} : {uproj.project_ws_id}
                    <input type='checkbox' disabled={isDisabled} id='favorite' className='chkbx' inputid='favorite' onClick={(e) => { if (!(updA || isDisabled || !writeAcc)) { setFav(!isFav) } }} value={(sctrl.data.favorite === 'Y') ? true : (sctrl.data.favorite === 'N') ? false : false} ></input>
                    <label htmlFor='favorite'>
                        {(isFav) && <BsStarFill className='reicn' style={{ marginBottom: '7px', color: '#DAA520' }} />}
                        {(!isFav) && <BsStar className='reicn' style={{ marginBottom: '7px', color: '#DAA520' }} />}
                    </label>
                </DialogTitle>
                <DialogContent>
                    <div>
                        <Tabs value={0} onChange={() => { }} >
                            <Tab label={t('Project Information')} />
                        </Tabs>
                        <TabPanel value={0} index={0}>

                            <Grid container className="marginRow muiForm mb-1" spacing={1.4}>
                                <Grid item sm={6} xs={12}>

                                    <TextField required disabled={updA || isDisabled || !writeAcc} label={t('Internal Project Name')}
                                        size="small"
                                        name="project_name" id="project_name" type="text" inputProps={{ maxLength: 240 }}
                                        defaultValue={uproj.project_name}
                                        onChange={(e) => handleChange(e)} error={errors.project_name ? true : false} />
                                </Grid>

                                <Grid item sm={6} xs={12}>

                                    <Autocomplete
                                        id="asynchronous-lead_project_manager"
                                        freeSolo
                                        open={openLpm}
                                        onOpen={() => {
                                            setOpenLpm(true);
                                        }}
                                        onClose={() => {
                                            setOpenLpm(false);
                                        }}
                                        isOptionEqualToValue={(option, value) => option.displayName === value.displayName}
                                        getOptionLabel={(option) => option.displayName || ''}
                                        onChange={(event, e) => handleChangeLpm(e)}
                                        defaultValue={{ displayName: lpm }}
                                        options={optionsLpm}
                                        disabled={updA || isDisabled || !writeAcc}
                                        loading={loadingLpm}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={t('Lead Project Manager')}
                                                name="lead_project_manager"
                                                id="lead_project_manager"
                                                size="small"
                                                defaultValue={lpm}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleChangeLpm(e);
                                                    }
                                                }}
                                                onChange={(e) => setLpm(e.target.value)}
                                                onKeyUp={(e) => {
                                                    if (lpm) {
                                                        applyDebounce(e, {
                                                            // hideloader: "adname_loader",
                                                            field: "lead_project_manager",
                                                        })
                                                    }
                                                }

                                                }
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {loadingLpm ? <CircularProgress color="inherit" size={20} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />

                                </Grid>
                                {/* 

                            <Grid item sm={6} xs={12}>  <div style={{position:'relative'}}>
                                <TextField fullWidth  label="Lead Project Manager" 
                                size="small" 
                                disabled={updA || isDisabled || !writeAcc} name='lead_project_manager' id='lead_project_manager' type='text' inputProps={{ maxLength: 240 }}
                                defaultValue={uproj.lead_project_manager} onChange={(e) => handleChange(e)}  onKeyUp={(e) => applyDebounce(e,{hideloader:'adname_loader',field:'lead_project_manager'})} />
                                <img src={gifLoader} id='adname_loader' alt='loading' className='adname-gif-loader' />
                                {showADSel &&
                                    <div className='search-sugg-sel-ad' id='search-sugg-sel-type'>
                                        {users !== null && users !== undefined && users.map((user, index) =>
                                            <div className="search-sugg-elem" key={index}>
                                                <label onClick={() => setCuser({dispName:user.displayName, field:'lead_project_manager',loader:'adname_loader'})}>{user.displayName}</label>
                                            </div>
                                        )}
                                    </div>}
                            </div> </Grid>
 */}



                                <Grid item sm={6} xs={12}>
                                    <TextField label={t('Project Number')} size="small" required
                                        name="project_number" id="project_number" type="text"

                                        disabled={updA || isDisabled || !writeAcc}
                                        //   defaultValue={sctrl.data.project_number}
                                        defaultValue={uproj.project_number}
                                        onChange={(e) => handleChange(e)}
                                        inputProps={{ maxLength: 50 }}
                                        error={errors.project_number ? true : false}
                                    /></Grid>
                                {/* <TextField label="Project Number" size="small"  
                             name="project_number" id="project_number" inputProps={{ maxLength: 240 }} type="text"
                              disabled={updA || isDisabled || !writeAcc} defaultValue={sctrl.data.project_number} /></Grid> */}


                                <Grid item sm={6} xs={12}>

                                    <Autocomplete
                                        id="asynchronous-lead_project_engineer"
                                        freeSolo
                                        open={openLpe}
                                        onOpen={() => {
                                            setOpenLpe(true);
                                        }}
                                        onClose={() => {
                                            setOpenLpe(false);
                                        }}
                                        isOptionEqualToValue={(option, value) => option.displayName === value.displayName}
                                        getOptionLabel={(option) => option.displayName || ''}
                                        disabled={updA || isDisabled || !writeAcc}
                                        onChange={(event, e) => handleChangeLpe(e)}
                                        defaultValue={{ displayName: lpe }}
                                        options={optionsLpe}
                                        loading={loadingLpe}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={t('Lead Project Engineer')}
                                                name="lead_project_engineer"
                                                id="lead_project_engineer"
                                                size="small"
                                                defaultValue={lpe}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleChangeLpe(e);
                                                    }
                                                }}
                                                onChange={(e) => setLpe(e.target.value)}
                                                onKeyUp={(e) => {
                                                    if (lpe) {
                                                        applyDebounce(e, {
                                                            // hideloader: "adname_loader",
                                                            field: "lead_project_engineer",
                                                        })
                                                    }
                                                }

                                                }
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {loadingLpe ? <CircularProgress color="inherit" size={20} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>



                                {/*                            
                            <Grid item sm={6} xs={12}>    
                             <div style={{position:'relative'}}>
                                <TextField label="Lead Project Engineer" size="small"  disabled={updA || isDisabled || !writeAcc} name='lead_project_engineer' 
                                id='lead_project_engineer' type='text' inputProps={{ maxLength: 240 }}
                                defaultValue={uproj.lead_project_engineer} onChange={(e) => handleChange(e)} onKeyUp={(e) => applyDebounce(e, { hideloader: 'adname_loader1', field: 'lead_project_engineer' })} onBlur={closeAD}  />
                                <img src={gifLoader} id='adname_loader1' alt='loading' className='adname-gif-loader' />
                                {showADSel1 &&
                                    <div className='search-sugg-sel-ad' id='search-sugg-sel-type'>
                                        {users !== null && users !== undefined && users.map((user, index) =>
                                            <div className="search-sugg-elem" key={index}>
                                                <label onClick={() => setCuser({dispName:user.displayName, field:'lead_project_engineer',loader:'adname_loader1'})}>{user.displayName}</label>
                                            </div>
                                        )}
                                    </div>
                                }                                
                            </div>  </Grid> */}


                                <Grid item sm={6} xs={12}>  <TextField
                                    select
                                    size="small"
                                    name="project_status"
                                    id="project_status"
                                    label={t('Project Status')}
                                    value={prjstat.value}
                                    inputProps={{ maxLength: 240 }}
                                    disabled={updA || isDisabled || !writeAcc}
                                    onChange={(e) => { setPrjstat({ value: e.target.value, label: e.target.value }) }}
                                >
                                    {sctrl.projStatus.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField></Grid>
                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        size="small"
                                        label={t('Business Unit')} name='world_area' id="world_area" type='text' inputProps={{ maxLength: 100 }} disabled={true}
                                        value={sctrl.data.world_area} /> </Grid>
                                <Grid item sm={6} xs={12}>   <TextField
                                    label={t('Created Date')}
                                    size="small"
                                    name='start_date' id="start_date" type='text' inputProps={{ maxLength: 100 }} disabled={true}
                                    defaultValue={(getDtfrmt(sctrl.data.start_date)).replace('--', '-')}
                                /> </Grid>
                                <Grid item sm={6} xs={12}>        <TextField

                                    label={t('Last Modified Date')}
                                    size="small"
                                    name='last_mod_date' id="last_mod_date" type='text' inputProps={{ maxLength: 100 }} disabled={true}
                                    defaultValue={(getDtfrmt(sctrl.data.last_mod_date)).replace('--', '-')}
                                /> </Grid>
                                <Grid item sm={6} xs={12}>
                                    <TextField size="small" label={t('Project Data Link Project Name')}
                                        disabled={updA || isDisabled || !writeAcc} name='pdl_project_name' id="pdl_project_name" type='text'
                                        inputProps={{
                                            maxlength: 240
                                        }}
                                        defaultValue={sctrl.data.pdl_project_name} /> </Grid>


                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        size='small'
                                        label={t('CRM Opportunity ID')}
                                        variant='outlined'
                                        color='success'
                                        name='crm_opp_num'
                                        id='crm_opp_num'
                                        type='text'
                                        inputProps={{ maxLength: 15, inputMode: 'numeric', pattern: '[0-9]*' }}
                                        onKeyPress={(e) => { if (!/[0-9]/.test(e.key)) e.preventDefault(); }}
                                        disabled={updA || isDisabled || !writeAcc}
                                        defaultValue={sctrl.data.crm_opp_num}
                                    />
                                </Grid>

                                <Grid item sm={6} xs={12}>
                                    <TextField
                                        select
                                        required
                                        size='small'
                                        label={t('Tier')}
                                        variant='outlined'
                                        color='success'
                                        name='tier'
                                        id='tier'
                                        value={tierValue}
                                        error={errors.tier ? true : false}
                                        disabled={updA || isDisabled || !writeAcc}
                                        onChange={(e) => { setTierValue(e.target.value); }}
                                        defaultValue={sctrl.data.tier}
                                    >
                                        {[1, 2, 3, 4, 5].map((val) => (
                                            <MenuItem key={val} value={val}>{val}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item sm={6} xs={12}>
                                    <TextField multiline rows={2} size="small" label={t('Project Background Information')}
                                        onChange={(e) => { console.log("euhdj", e.target.value) }}
                                        disabled={updA || isDisabled || !writeAcc} name='project_bg_info' id="project_bg_info" type='textarea'
                                        defaultValue={sctrl.data.project_bg_info}
                                        inputProps={{
                                            maxlength: 240
                                        }}
                                    />
                                </Grid>

                            </Grid>




                        </TabPanel>
                        {/* <TabPane tabId={'2'}>
                            <Row className='marginRow1'>
                                <Col md={2}>
                                    <Label>Master Project</Label>
                                </Col>
                                <Col md={4}>
                                        <div style={{ position: 'relative', display: 'block' }}>
                                            <img src={gifLoader} id='master_project_loader' alt='loading' className='proj-gif-loader' />
                                <Input disabled={isDisabled} bsSize="sm" name="master_project" id="master_project" type="text" inputProps={{ maxLength: 240 }} autoComplete='off'
                                    defaultValue={sctrl.data.master_project} onChange={(e) => handleChange(e) } onKeyUp={(event)=>showMsPrjSel(event)} onBlur={closecSelD} />
                                {showMsPrjhSel &&
                                            <div className='proj-sel' id='master-proj-sel'>
                                                {masterProjects.map((msPrj,index)=>
                                                    <div className="proj-sel-elem" key={index} onClick={()=>setMsPrj(msPrj.proj_list)}>
                                                        <label cus-sel='true' >{msPrj.proj_list}</label>
                                                    </div>
                                                )}
                                            </div>
                                        }
                                        </div>
                                </Col>
                                <Col md={2}>
                                    <Label>Currency</Label>
                                </Col>
                                <Col md={4}> */}

                        {/*<Input bsSize="sm" name="currency" id="currency" type="text" inputProps={{ maxLength: 100 }} defaultValue={sctrl.data.currency} onChange={(e) => handleChange(e) } />*/}
                        {/* <Select name="currency" id ="currency" disabled={isDisabled} /*defaultValue={{Value: sctrl.data.project_status,label:stLabel}} onChange={(e) => handleProject(e) } */}
                        {/* styles={customStyles}  options={sctrl.currencies} defaultValue = {{Value: sctrl.data.currency, label: currLbl}} onChange={(e) => handleCurrency(e) }/> */}
                        {/* </Col> */}
                        {/* </Row> */}
                        {/* <Row className='marginRow'> */}
                        {/* <Col md={2}> */}
                        {/* <Label>Sub Projects</Label> */}
                        {/* </Col> */}
                        {/* <Col md={4}> */}
                        {/* <Input bsSize="sm" name="sub_project" id="sub_project" type="textarea" inputProps={{ maxLength: 100 }} defaultValue={sctrl.data.sub_project} */}
                        {/* style={{ height: "7pc" }} disabled={true} /*onChange={(e) => handleChange(e)} */}
                        {/* </Col> */}
                        {/* <Col > */}
                        {/* <Row  className='marginRow1'> */}
                        {/* <Col md={4}> */}
                        {/* <Label>Pricing Region</Label> */}
                        {/* </Col> */}
                        {/* <Col md={8}> */}
                        {/*<Input bsSize="sm" name="pricing_region" id="pricing_region" type="text" inputProps={{ maxLength: 100 }} defaultValue={sctrl.data.pricing_region} onChange={(e) => handleChange(e) } />*/}
                        {/* <Select disabled={isDisabled} name="pricing_region" options={sctrl.pricingRegion} onChange={(e) => handlePriceReg(e)} */}
                        {/* styles={customStyles} defaultValue ={{value: sctrl.data.pricing_region ,label: prcRegLbl }} /> */}
                        {/* </Col> */}
                        {/* </Row> */}
                        {/* <Row className='marginRow1'> */}
                        {/* <Col md={4}> */}
                        {/* <Label>Pricing Date</Label> */}
                        {/* </Col> */}
                        {/* <Col md={8}> */}
                        {/*<Input bsSize="sm" name="pricing_date" id="pricing_date" type="text" inputProps={{ maxLength: 100 }} /*value={sctrl.data.pricing_date} /*onChange={(e) => handleChange(e) } />*/}
                        {/* <DatePicker selected={priceDate?priceDate:null} name ="pricing_date" */}
                        {/* onChange={date => /setPriceDate(date)} */}
                        {/* className="react-datepicker dtwdt1" */}
                        {/* placeholderText="DD-MMM-YYYY" */}
                        {/* dateFormat="dd-MMM-yyyy" */}
                        {/* showMonthDropdown */}
                        {/* showYearDropdown */}
                        {/* dropdownMode="select" */}
                        {/* disabled={isDisabled} */}
                        {/* //defaultValue={sctrl.data.pricing_date} */}
                        {/* //fixedHeight */}
                        {/* //style={{height:'5px'}} */}
                        {/* /> */}
                        {/* </Col> */}
                        {/* </Row> */}
                        {/* <Row className='marginRow1'> */}
                        {/* <Col md={4}> */}
                        {/* <Label>Pricelist</Label> */}
                        {/* </Col> */}
                        {/* <Col md={8}> */}
                        {/* <div style={{ position: 'relative', display: 'block' }}> */}
                        {/* <img src={gifLoader} id='pricelist_loader' alt='loading' className='proj-gif-loader' /> */}
                        {/* <Input bsSize="sm" name="pricelist" id="pricelist" type="text" inputProps={{ maxLength: 100 }} onKeyUp={(event) => showPriceLstSel(event)} onBlur={closecSelD} autoComplete='off' defaultValue={sctrl.data.pricelist}/> */}
                        {/* {showPLSel && */}
                        {/* <div className='proj-sel' id='pl-proj-sel'> */}
                        {/* {fltrdPriceList.map((pl,index)=> */}
                        {/* <div className="proj-sel-elem" onClick={()=>setPL(pl.value)} key={index}> */}
                        {/* <label >{pl.value}</label> */}
                        {/* </div> */}
                        {/* )} */}
                        {/* </div> */}
                        {/* }</div> */}
                        {/* <Select name="pricelist" id ="pricelist" /*defaultValue={{Value: sctrl.data.project_status,label:stLabel}} onChange={(e) => handleProject(e) }
                                            styles={customStyles}  options={sctrl.priceList}/>                                     */}
                        {/* </Col> */}
                        {/* </Row> */}
                        {/* </Col> */}
                        {/* </Row> */}
                        {/* </TabPane> */}
                        {/* </TabContent> */}
                    </div>
                </DialogContent>
                <DialogActions className='model-actions'>
                    <Button className="cnbtn btn btn-outline-success" variant="outlined" onClick={() => { setProjectNumberChanged(false); dispatch(showUpdProj({ updProj: false, data: uproj })); setErrors({}); setUsers(null); setShowSrchSel(false); setshowADSel(false); setshowADSel1(false); showHideElem('adname_loader', 'hide'); showHideElem('adname_loader1', 'hide'); dispatch(hideUpdProj(false)) }} style={{ "marginRight": "5px" }}>
                        {t('Cancel')}
                    </Button>
                    <Button className="sbtn btn btn-secondary right-space-btn-min" variant="contained" color="success" onClick={() => updateProjct()} disabled={updA || isDisabled || !writeAcc}>
                        {t('Save')}
                    </Button>
                    {/*<Button outline color='success' className='cnbtn' onClick={()=>{setErrors({}); dispatch(hideUpdProj(false))} } >Cancel</Button>*/}
                    {/* <BtnC outline={true} color='success' className='cnbtn'  label='Cancel' /> */}
                    {/*<Button className="sbtn"  onClick={()=> updateProjct()} >
                    <span style={{color:'white', width: '2pc'}} >Save</span>
                </Button>*/}
                    {/* <BtnC outline={false} className="sbtn"  label='Save' style={{ color: 'white', width: '2pc' }} disabled={updA || isDisabled} /> */}
                </DialogActions>
            </Dialog>
        </>
    )
}

export default UpdateProject;